<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" class="tab-out">
      <el-tab-pane label="学图谱" name="first" class="con">
        <div class="con-l">
          <span class="topic">{{ mapActiveLabel }}</span>
          <Graph
            @getMapData="getMapData"
            @changeMapActiveName="changeMapActiveName"
          ></Graph>
        </div>
        <div class="con-r">
          <el-tabs
            v-model="tabActiveName"
            @tab-click="handleClick"
            class="tab-in"
          >
            <el-tab-pane
              v-for="(item, i) in tabList"
              :name="i.toString()"
              :key="item.id"
            >
              <span slot="label">{{ item.columnName }}</span>
              <el-empty v-if="!list.length && !loading" description="暂无内容"></el-empty>
              <el-scrollbar v-loading="loading" v-else style="height: 375px">
                <ul
                  class="tab-list tab-list0"
                  v-if="tabActiveName === '0'"
                >
                  <li v-for="(it, i) in list" :key="i">
                      <span class="topic">{{ it.buildContent }}</span>
                      <span class="info">{{ it.buildSource }}</span>
                  </li>
                </ul>
                <ul class="tab-list tab-list1" v-else>
                  <li v-for="(it, i) in list" :key="i">
                    <a :href="it.nodeUrl" target="_blank">
                      <span class="topic" :title="it.title">{{
                        it.title
                      }}</span>
                    </a>
                      <span
                        class="source"
                        :title="tabActiveName === '4' ? it.author : it.source"
                        >{{
                          tabActiveName === "4"
                            ? it.author && it.author.replace(/;$/, "")
                            : it.source
                        }}</span
                      >
                      <span class="time">{{ it.pubDate&&it.pubDate.slice(0,10) }}</span>
                  </li>
                </ul>
                <div class="more-box">
                  <el-link
                    v-if="tabActiveName !== '0' && list.length && list.length>5"
                    class="more"
                    type="info"
                    :href="
                      tabActiveName === '4'
                        ? `/#/result/2/${tabUidList[Number(tabActiveName)]}`
                        : `/#/result/${Number(tabActiveName) + 2}/${tabUidList[Number(tabActiveName)]}`
                    "
                    target="_blank"
                  >
                    查看更多
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#iconmore"></use>
                    </svg>
                  </el-link>
                </div>
              </el-scrollbar>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-tab-pane>
      <el-tab-pane label="学原著" name="second" class="journal wid-1200">
        <Writings :downloadUrl="downloadUrl"></Writings>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Graph from "./Graph.vue";
import Writings from "./Writings.vue";
export default {
  name: "AtlasAndOriginal",
  props: ["downloadUrl"],
  components: {
    Graph,
    Writings,
  },
  data() {
    return {
      activeName: "first",
      mapActiveName: "0",
      mapActiveLabel: "",
      tabActiveName: "0",
      mapData: [],
      list: [],
      tabList: [],
      uidList: [],
      tabUidList: [],
      journalData: [], //学习著作
      breadcrumb: '',
      loading: false
    };
  },
  methods: {
    getMapData(arr) {
      this.uidList = arr.map((item) => item.uid);
      this.mapActiveName = (this.uidList.length - 1).toString() // 最后一个是“全部”，默认按全部检索
      this.tabActiveName = "0";
      this.getTabList();
    },
    // 获取图谱节点对应的右侧列表
    getTabList() {
      this.axios
        .get(
          `data/custom/classType?uid=${
            this.uidList[Number(this.mapActiveName)]
          }&pageNum=1&pageSize=10`
        )
        .then((res) => {
          if (res.status == 200) {
            if (!res.data) return;
            this.tabList = res.data.rows;
            this.tabUidList = this.tabList.map((item) => item.uid);
            this.breadcrumb = `理论学习>学图谱>${this.mapActiveLabel}`
            this.getList();
            console.log(this.getList(),"this.getList()")
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    // 获取右侧当前tab对应的列表
    getList() {
      this.loading = true
      if (this.tabActiveName === "0") {
        this.axios
          .post("data/custom/buildlist", {
            uid: this.tabUidList[Number(this.tabActiveName)],
            pageNum: 1,
            pageSize: 10,
          })
          .then((res) => {
            this.loading = false
            if (res.status == 200) {
              this.list = res.data.rows.filter((item, i) => i < 6);
            } else {
              this.$message.error("获取失败！");
            }
          })
          .catch(() => {
            this.list = [];
            this.$message.error("文献加载失败，请稍后重试！");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.axios
          .post(`data/cnki/getKbaseList`, {
            uid: this.tabUidList[Number(this.tabActiveName)],
            pageNum: 1,
            pageSize: 10,
          })
          .then((res) => {
            this.loading = false
            if (res.status == 200) {
              if (!res.data) return;
              this.list = res.data.rows.filter((item, i) => i < 6);
            } else {
              this.$message.error("获取失败！");
            }
          })
          .catch(() => {
            this.list = [];
            this.$message.error("文献加载失败，请稍后重试！");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    handleClick(tab, event) {
      this.list = []
      this.getList();
    },
    changeMapActiveName(val, label) {
      this.mapActiveName = val.toString();
      this.tabActiveName = "0";
      this.mapActiveLabel = label;
      this.getTabList();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-tabs__nav-wrap::after {
    content: none;
  }
  .el-tabs__active-bar {
    display: none;
  }
  .el-tabs__item {
    font-size: 16px;
    &:hover {
      color: #bd1a2d;
    }
  }
  .tab-out {
    line-height: 1.6;
    & > .el-tabs__header {
      text-align: center;
      height: 37px;
      text-align: center;
      font-weight: 700;
      font-size: 28px;
      line-height: 37px;
      color: #bd1a2d;
      background: url(../../assets/images/title_bg_l.png) no-repeat -73px center,
        url(../../assets/images/title_bg_r.png) no-repeat calc(100% + 73px)
          center;
      margin: 25px 0;
      .el-tabs__item {
        font-size: 28px;
        font-weight: bold;
        &.is-active {
          color: #bd1a2d;
        }
      }
    }
  }

  .tab-in {
    .el-tabs__header {
      background: linear-gradient(
        180deg,
        #ffd3d3 0%,
        #ffeeee 0.01%,
        #ffffff 100%
      );
      margin-bottom: 0;
    }
    .el-tabs__item {
      font-weight: bold;
      height: 50px;
      line-height: 50px;
      padding: 0 25px;
      &.is-top {
        &:nth-child(2) {
          padding-left: 25px;
        }
        &:last-child {
          padding-right: 25px;
        }
      }
      &.is-active {
        color: #fff;
        background: linear-gradient(90deg, #bd1a2d 0.09%, #ec0e0e 100%);
      }
    }
    .el-tabs__content {
      padding: 0 10px 25px;
      margin-top: 10px;
    }
    .tab-list {
      padding: 0 10px;
      .topic{
        color: #666;
      }
      &.tab-list0{
        .topic{
          user-select: none;
        }
      }
      &:not(.tab-list0){
        .topic{
        &:hover{
          color: #bd1a2d;
        }
      }
      }
    }
  }
  .el-tabs__nav {
    float: none;
  }
}
.con {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  .con-l {
    width: 590px;
    height: 437px;
    background: linear-gradient(
      180deg,
      #ffd3d3 0%,
      #ffeeee 0.01%,
      #ffffff 50.52%,
      #ffeeee 99.48%
    );
    padding: 17px;
    margin-right: 20px;
    flex-shrink: 0;
    .topic {
      background: linear-gradient(180deg, #c53747 0%, #ff6e4e 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      display: block;
    }
  }
  .con-r {
    flex: 1;
    li {
      border-bottom: 1px dotted #b1aeae;
      padding: 10px;
      &:last-child {
        border-bottom: none;
      }
      .info {
        display: block;
        color: #9f9fa6;
        text-align: right;
        margin-top: 10px;
      }
    }
    .more {
      bottom: 0;
      right: 0;
    }
    .tab-list0 {
      .topic {
        display: block;
        text-indent: 2em;
      }
    }
    .tab-list1 {
      .topic,
      .source {
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        margin-right: 10px;
      }
      .topic {
        width: 22em;
      }
      .source {
        width: 8em;
        color: #999;
      }
    }
  }
}
</style>
